export default __webpack_public_path__ + "static/SRUS P170 - Especification Del Producto y Datos Técnicos-c2343a7823c37c4c44b38bfd732d562c.pdf";